import { DesktopClassicIcon } from './DesktopClassicIcon';

/**
 * author: GreenTurtwig
 * id 40B89929-0709-461F-8C7A-ED94CDDCC4AC
 * name desktop-classic
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/desktop-classic.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const ComputerClassicIcon = DesktopClassicIcon;
export default ComputerClassicIcon